// Money & date formatting helpers. All currency is Indian Rupees.

const inr = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const inrNumber = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const intFmt = new Intl.NumberFormat('en-IN');

/** ₹1,234.56 — safely handles null/undefined/NaN. */
export function money(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return inr.format(0);
  return inr.format(value);
}

/** 1,234.56 without the currency symbol (for CSV-like inline use). */
export function amount(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return inrNumber.format(0);
  return inrNumber.format(value);
}

/** 1,23,456 grouped integer. */
export function count(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '0';
  return intFmt.format(value);
}

export function percent(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '0%';
  return `${inrNumber.format(value)}%`;
}

/** 10 Sep 2026, 3:45 PM in the store's local time. */
export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function dateOnly(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** YYYY-MM-DD for a Date (local). */
export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Start of day as ISO date-time (local midnight). */
export function startOfDayISO(dateStr: string): string {
  return `${dateStr}T00:00:00`;
}

/** End of day as ISO date-time. */
export function endOfDayISO(dateStr: string): string {
  return `${dateStr}T23:59:59`;
}
